var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWavesBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 334,
    height: 322,
    viewBox: "0 0 334 322",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M471.97 254.776L465.284 252.067C416.882 232.454 365.182 271.95 371.379 323.807L372.269 331.259C378.094 380.001 329.302 416.994 283.943 398.226L268.08 391.663C235.261 378.083 198.805 400.737 196.446 436.176V436.176",
    stroke: "#F25858",
    strokeWidth: 0.869375
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.079 250.959L462.394 248.25C413.991 228.637 362.292 268.134 368.488 319.99L369.379 327.443C375.204 376.185 326.412 413.177 281.053 394.409L265.19 387.846C232.371 374.267 195.914 396.921 193.555 432.36V432.36",
    stroke: "#F25858",
    strokeWidth: 0.869375
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.188 247.143L459.503 244.434C411.1 224.821 359.4 264.317 365.597 316.174L366.488 323.626C372.313 372.368 323.521 409.36 278.162 390.593L262.299 384.029C229.48 370.45 193.023 393.104 190.664 428.543V428.543",
    stroke: "#F25858",
    strokeWidth: 0.869375
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.298 243.326L456.613 240.617C408.21 221.004 356.511 260.5 362.707 312.357L363.598 319.809C369.423 368.551 320.631 405.544 275.272 386.776L259.409 380.213C226.59 366.633 190.133 389.287 187.774 424.726V424.726",
    stroke: "#F25858",
    strokeWidth: 0.869375
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.407 239.51L453.722 236.801C405.319 217.187 353.619 256.684 359.816 308.54L360.707 315.993C366.531 364.735 317.74 401.727 272.381 382.959L256.518 376.396C223.699 362.817 187.242 385.471 184.883 420.91V420.91",
    stroke: "#F25858",
    strokeWidth: 0.869375
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.517 235.692L450.831 232.983C402.429 213.37 350.729 252.866 356.926 304.723L357.817 312.175C363.641 360.917 314.85 397.91 269.49 379.142L253.628 372.578C220.808 358.999 184.352 381.653 181.993 417.092V417.092",
    stroke: "#F25858",
    strokeWidth: 0.869375
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.626 231.876L447.941 229.167C399.538 209.554 347.838 249.05 354.035 300.907L354.926 308.359C360.75 357.101 311.959 394.093 266.6 375.326L250.737 368.762C217.918 355.183 181.461 377.837 179.102 413.276V413.276",
    stroke: "#F25858",
    strokeWidth: 0.869375
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.736 228.059L445.05 225.35C396.647 205.737 344.948 245.233 351.145 297.09L352.035 304.542C357.86 353.284 309.068 390.277 263.709 371.509L247.846 364.945C215.027 351.366 178.571 374.02 176.211 409.459V409.459",
    stroke: "#F25858",
    strokeWidth: 0.869375
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.845 224.243L442.16 221.534C393.757 201.921 342.057 241.417 348.254 293.273L349.145 300.726C354.969 349.468 306.178 386.46 260.819 367.692L244.956 361.129C212.137 347.55 175.68 370.204 173.321 405.643V405.643",
    stroke: "#F25858",
    strokeWidth: 0.869375
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.954 220.426L439.269 217.717C390.866 198.104 339.167 237.6 345.363 289.457L346.254 296.909C352.079 345.651 303.287 382.643 257.928 363.876L242.065 357.312C209.246 343.733 172.789 366.387 170.43 401.826V401.826",
    stroke: "#F25858",
    strokeWidth: 0.869375
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.064 216.609L436.379 213.9C387.976 194.287 336.276 233.783 342.473 285.64L343.364 293.092C349.189 341.834 300.397 378.827 255.038 360.059L239.175 353.495C206.356 339.916 169.899 362.57 167.54 398.009V398.009",
    stroke: "#F25858",
    strokeWidth: 0.869375
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.173 212.792L433.488 210.083C385.085 190.47 333.386 229.967 339.582 281.823L340.473 289.276C346.298 338.018 297.506 375.01 252.147 356.242L236.284 349.679C203.465 336.1 167.008 358.754 164.649 394.193V394.193",
    stroke: "#F25858",
    strokeWidth: 0.869375
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.283 208.976L430.597 206.267C382.195 186.654 330.495 226.15 336.692 278.007L337.582 285.459C343.407 334.201 294.615 371.193 249.256 352.426L233.393 345.862C200.574 332.283 164.118 354.937 161.758 390.376V390.376",
    stroke: "#F25858",
    strokeWidth: 0.869375
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.392 205.158L427.706 202.449C379.304 182.836 327.604 222.332 333.801 274.189L334.692 281.641C340.516 330.383 291.725 367.376 246.365 348.608L230.503 342.045C197.683 328.465 161.227 351.119 158.868 386.558V386.558",
    stroke: "#F25858",
    strokeWidth: 0.869375
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.502 201.342L424.816 198.633C376.413 179.019 324.714 218.516 330.911 270.372L331.801 277.825C337.626 326.567 288.834 363.559 243.475 344.791L227.612 338.228C194.793 324.649 158.336 347.303 155.977 382.742V382.742",
    stroke: "#F25858",
    strokeWidth: 0.869375
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.679 197.615L421.994 194.906C373.591 175.293 321.891 214.79 328.088 266.646L328.979 274.099C334.804 322.84 286.012 359.833 240.653 341.065L224.79 334.502C191.971 320.922 155.514 343.576 153.155 379.015V379.015",
    stroke: "#F25858",
    strokeWidth: 0.869375
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.857 193.889L419.172 191.18C370.769 171.567 319.069 211.063 325.266 262.92L326.157 270.372C331.982 319.114 283.19 356.106 237.831 337.339L221.968 330.775C189.149 317.196 152.692 339.85 150.333 375.289V375.289",
    stroke: "#F25858",
    strokeWidth: 0.869375
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.035 190.163L416.35 187.454C367.947 167.841 316.247 207.337 322.444 259.193L323.335 266.646C329.16 315.388 280.368 352.38 235.009 333.612L219.146 327.049C186.327 313.47 149.87 336.124 147.511 371.563V371.563",
    stroke: "#F25858",
    strokeWidth: 0.869375
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.213 186.436L413.527 183.727C365.124 164.114 313.425 203.611 319.622 255.467L320.512 262.92C326.337 311.661 277.545 348.654 232.186 329.886L216.323 323.323C183.504 309.743 147.048 332.398 144.688 367.837V367.837",
    stroke: "#F25858",
    strokeWidth: 0.869375
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.39 182.71L410.705 180.001C362.302 160.388 310.603 199.884 316.8 251.741L317.69 259.193C323.515 307.935 274.723 344.928 229.364 326.16L213.501 319.596C180.682 306.017 144.225 328.671 141.866 364.11V364.11",
    stroke: "#F25858",
    strokeWidth: 0.869375
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.569 178.984L407.883 176.275C359.48 156.662 307.781 196.158 313.978 248.015L314.868 255.467C320.693 304.209 271.901 341.201 226.542 322.434L210.679 315.87C177.86 302.291 141.404 324.945 139.044 360.384V360.384",
    stroke: "#F25858",
    strokeWidth: 0.869375
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.746 175.257L405.061 172.548C356.658 152.935 304.959 192.432 311.155 244.288L312.046 251.741C317.871 300.482 269.079 337.475 223.72 318.707L207.857 312.144C175.038 298.564 138.581 321.218 136.222 356.657V356.657",
    stroke: "#F25858",
    strokeWidth: 0.869375
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.924 171.531L402.239 168.822C353.836 149.209 302.136 188.705 308.333 240.562L309.224 248.014C315.048 296.756 266.257 333.748 220.898 314.98L205.035 308.417C172.216 294.838 135.759 317.492 133.4 352.931V352.931",
    stroke: "#F25858",
    strokeWidth: 0.869375
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.102 167.804L399.417 165.095C351.014 145.482 299.314 184.978 305.511 236.835L306.402 244.287C312.226 293.029 263.435 330.022 218.076 311.254L202.213 304.69C169.394 291.111 132.937 313.765 130.578 349.204V349.204",
    stroke: "#F25858",
    strokeWidth: 0.869375
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.28 164.078L396.594 161.369C348.191 141.756 296.492 181.252 302.689 233.109L303.579 240.561C309.404 289.303 260.612 326.296 215.253 307.528L199.39 300.964C166.571 287.385 130.114 310.039 127.755 345.478V345.478",
    stroke: "#F25858",
    strokeWidth: 0.869375
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.458 160.351L393.772 157.642C345.369 138.029 293.67 177.526 299.867 229.382L300.757 236.835C306.582 285.576 257.79 322.569 212.431 303.801L196.568 297.238C163.749 283.659 127.293 306.313 124.933 341.752V341.752",
    stroke: "#F25858",
    strokeWidth: 0.869375
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.636 156.625L390.95 153.916C342.547 134.303 290.848 173.799 297.045 225.656L297.935 233.108C303.76 281.85 254.968 318.843 209.609 300.075L193.746 293.511C160.927 279.932 124.471 302.586 122.111 338.025V338.025",
    stroke: "#F25858",
    strokeWidth: 0.869375
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.813 152.899L388.128 150.19C339.725 130.577 288.026 170.073 294.222 221.93L295.113 229.382C300.938 278.124 252.146 315.116 206.787 296.349L190.924 289.785C158.105 276.206 121.648 298.86 119.289 334.299V334.299",
    stroke: "#F25858",
    strokeWidth: 0.869375
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.991 149.172L385.306 146.463C336.903 126.85 285.203 166.347 291.4 218.203L292.291 225.656C298.116 274.398 249.324 311.39 203.965 292.622L188.102 286.059C155.283 272.48 118.826 295.134 116.467 330.573V330.573",
    stroke: "#F25858",
    strokeWidth: 0.869375
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWavesBottom);
export default __webpack_public_path__ + "static/media/waves_bottom.68dc265b6b09e7eeea98af9e46814be6.svg";
export { ForwardRef as ReactComponent };